import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './DigitalCoins.css';
import { fetchAllDigitalCoinsById } from '../../../Common/SharedApis/DespositMethods.tsx';
import { useLoading } from '../../../contexts/LoadingContext.tsx'; // Import the loading context
import axios from 'axios';

interface DigitalCurrency {
  digitalCoinId: number;
  coinName: string;
  coinLogo: string;
  chainName: string;
  active: boolean;
  entryDateTime: string;
  depositAddress: string;
  depositMethodId: number;
}

const DigitalCoins: React.FC = () => {
  const { depositMethodId } = useParams<{ depositMethodId: string }>();
  const navigate = useNavigate();
  const [digitalCurrencies, setDigitalCurrencies] = useState<DigitalCurrency[]>([]);
  const { isLoading, setIsLoading } = useLoading(); // Get loading context

  useEffect(() => {
    const fetchData = async () => {
      if (depositMethodId) {
        setIsLoading(true); // Set loading state to true
        try {
          const data = await fetchAllDigitalCoinsById(parseInt(depositMethodId));
          if (Array.isArray(data)) {
            setDigitalCurrencies(data);
          } else {
            console.error('Unexpected data format:', data);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          setIsLoading(false); // Set loading state to false
        }
      } else {
        console.error('DepositMethodId is undefined');
        setIsLoading(false); // Set loading state to false
      }
    };

    fetchData();
  }, [depositMethodId, setIsLoading]);

  const handleBackClick = () => {
    navigate(-1);
  };

  

  const GoToDigitalCurrencyDepositClick = async (
    digitalCoinId: number,
    coinName: string,
    coinLogo: string,
    chainName: string
  ) => {
    // Fetch price when the coin is clicked
  
    // Navigate to the deposit page with the price
    navigate(`/DigitalCurrencyDeposit/${digitalCoinId}`, {
      state: {
        digitalCoinId,
        coinName,
        coinLogo,
        chainName,
       
      },
    });
  };

  return (
  
   <>
    <div className="digital-currency-container">
      <div className="digital-currency-header">
        <button className="digital-currency-back-button" onClick={handleBackClick}>←</button>
        <h1 className="digital-currency-title">Digital currency deposit</h1>
      </div>
      <div className="info-box">
  <ol>
    <li>
      After receiving your deposit, we will convert it into U.S. dollars based on your deposited digital currency. After the deposit is completed, please submit the deposit voucher and contact our customer service staff.
    </li>
    <li>
      Please fill in the actual deposit amount truthfully, otherwise it may cause the system audit to fail and affect the deposit progress.
    </li>
  </ol>
</div>

      
      <div className="digital-currency-list">
        {isLoading && <p>Loading...</p>}
        {!isLoading && digitalCurrencies.length === 0 && <p>No digital currencies found.</p>}

        <h4>Please select Coin</h4>
        {digitalCurrencies.length > 0 ? (
          digitalCurrencies.map(currency => (
            <div
              key={currency.digitalCoinId}
              className="digital-currency-detail"
              onClick={() => GoToDigitalCurrencyDepositClick(
                currency.digitalCoinId,
                currency.coinName,
                currency.coinLogo,
                currency.chainName
              )}
            >
              <div className="digital-currency-detail-icon">
                <img
                  src={currency.coinLogo}
                  alt={currency.coinName}
                  className="digital-currency-icon"
                />
              </div>
              <div className="digital-currency-detail-info">
                <p className="coin-name">{currency.coinName}</p>
                <p className="coin-chain">Chain: {currency.chainName}</p>
                <span className="arrow-icon">{'>'}</span>
              </div>
            </div>
          ))
        ) : (
          <p>No digital currencies found.</p>
        )}
      </div>

      <div className="digital-currency-container">
   
      <div className="digital-currency-container">
    {/* Existing components... */}

    <div className="supported-services-section">
      <h4>Supported Services</h4>
      <div className="supported-services-grid">
        <div className="service-item">
          <img src="https://example.com/logos/moonpay.png" alt="MoonPay" />
          <span>MoonPay</span>
        </div>
        <div className="service-item">
          <img src="https://example.com/logos/coinbase.png" alt="Coinbase" />
          <span>Coinbase</span>
        </div>
        <div className="service-item">
          <img src="https://example.com/logos/changelly.png" alt="Changelly" />
          <span>Changelly</span>
        </div>
        <div className="service-item">
          <img src="https://example.com/logos/paxful.png" alt="PAXFUL" />
          <span>PAXFUL</span>
        </div>
        <div className="service-item">
          <img src="https://example.com/logos/okex.png" alt="OKEX" />
          <span>OKEX</span>
        </div>
        <div className="service-item">
          <img src="https://example.com/logos/bitcoin.png" alt="Bitcoin" />
          <span>Bitcoin</span>
        </div>
        <div className="service-item">
          <img src="https://example.com/logos/banx.png" alt="BANX△" />
          <span>BANX△</span>
        </div>
      </div>
    </div>
  </div>

    </div>

  </div>

  </>
  );
};

export default DigitalCoins;
